export default __webpack_public_path__ + "static/media/whatsapp.d1973592.svg";